// CRUD product list Action Types

// get product list Action Types
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS";
export const GET_PRODUCT_LIST_ERROR = "GET_PRODUCT_LIST_ERROR";

// Product Unit Action Types
// GET Product Unit Types List

export const GET_PRODUCT_UNIT_TYPE_LIST = "GET_PRODUCT_UNIT_TYPE_LIST";
export const GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS =
  "GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS";
export const GET_PRODUCT_UNIT_TYPE_LIST_ERROR =
  "GET_PRODUCT_UNIT_TYPE_LIST_ERROR";

// Add Product Unit Type
export const ADD_PRODUCT_UNIT_TYPE = "ADD_PRODUCT_UNIT_TYPE";
export const ADD_PRODUCT_UNIT_TYPE_SUCCESS = "ADD_PRODUCT_UNIT_TYPE_SUCCESS";
export const ADD_PRODUCT_UNIT_TYPE_ERROR = "ADD_PRODUCT_UNIT_TYPE_ERROR";

// Update Product Unit Type
export const UPDATE_PRODUCT_UNIT_TYPE = "UPDATE_PRODUCT_UNIT_TYPE";
export const UPDATE_PRODUCT_UNIT_TYPE_SUCCESS =
  "UPDATE_PRODUCT_UNIT_TYPE_SUCCESS";
export const UPDATE_PRODUCT_UNIT_TYPE_ERROR = "UPDATE_PRODUCT_UNIT_TYPE_ERROR";

// Delete Product Unit Type
export const DELETE_PRODUCT_UNIT_TYPE = "DELETE_PRODUCT_UNIT_TYPE";
export const DELETE_PRODUCT_UNIT_TYPE_SUCCESS =
  "DELETE_PRODUCT_UNIT_TYPE_SUCCESS";
export const DELETE_PRODUCT_UNIT_TYPE_ERROR = "DELETE_PRODUCT_UNIT_TYPE_ERROR";

///productstockstoragelocation/list
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST";
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS";
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR";

///productstockstoragelocation/data
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA";
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS";
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR =
  "GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR";

///productstockstoragelocation/create
export const CREATE_PRODUCT_STOCK_STORAGE_LOCATION =
  "CREATE_PRODUCT_STOCK_STORAGE_LOCATION";
export const CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS =
  "CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS";
export const CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR =
  "CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR";

///productstockstoragelocation/update
export const UPDATE_PRODUCT_STOCK_STORAGE_LOCATION =
  "UPDATE_PRODUCT_STOCK_STORAGE_LOCATION";
export const UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS =
  "UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS";
export const UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR =
  "UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR";

///productstockstoragelocation/delete
export const DELETE_PRODUCT_STOCK_STORAGE_LOCATION =
  "DELETE_PRODUCT_STOCK_STORAGE_LOCATION";
export const DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS =
  "DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS";
export const DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR =
  "DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR";

///productstock/list
export const GET_PRODUCT_STOCK_LIST = "GET_PRODUCT_STOCK_LIST";
export const GET_PRODUCT_STOCK_LIST_SUCCESS = "GET_PRODUCT_STOCK_LIST_SUCCESS";
export const GET_PRODUCT_STOCK_LIST_ERROR = "GET_PRODUCT_STOCK_LIST_ERROR";

///productstock/search
export const SEARCH_PRODUCT_STOCK = "SEARCH_PRODUCT_STOCK";
export const SEARCH_PRODUCT_STOCK_SUCCESS = "SEARCH_PRODUCT_STOCK_SUCCESS";
export const SEARCH_PRODUCT_STOCK_ERROR = "SEARCH_PRODUCT_STOCK_ERROR";

///productstocktransaction/search
export const SEARCH_PRODUCT_STOCK_TRANSACTION =
  "SEARCH_PRODUCT_STOCK_TRANSACTION";
export const SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS =
  "SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS";
export const SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR =
  "SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR";

///productstocktransaction/list
export const GET_PRODUCT_STOCK_TRANSACTION_LIST =
  "GET_PRODUCT_STOCK_TRANSACTION_LIST";
export const GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS =
  "GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS";
export const GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR =
  "GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR";

///productstocktransaction/add
export const ADD_PRODUCT_STOCK_TRANSACTION = "ADD_PRODUCT_STOCK_TRANSACTION";
export const ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS =
  "ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS";
export const ADD_PRODUCT_STOCK_TRANSACTION_ERROR =
  "ADD_PRODUCT_STOCK_TRANSACTION_ERROR";

///productstocktransaction/move
export const MOVE_PRODUCT_STOCK_TRANSACTION = "MOVE_PRODUCT_STOCK_TRANSACTION";
export const MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS =
  "MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS";
export const MOVE_PRODUCT_STOCK_TRANSACTION_ERROR =
  "MOVE_PRODUCT_STOCK_TRANSACTION_ERROR";

///productstocktransaction/reduce
export const REDUCE_PRODUCT_STOCK_TRANSACTION =
  "REDUCE_PRODUCT_STOCK_TRANSACTION";
export const REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS =
  "REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS";
export const REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR =
  "REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR";

///productstocktransactionreason/list
export const GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST =
  "GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST";
export const GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS =
  "GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS";
export const GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR =
  "GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR";

///productstocktransactionreason/create
export const CREATE_PRODUCT_STOCK_TRANSACTION_REASON =
  "CREATE_PRODUCT_STOCK_TRANSACTION_REASON";
export const CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS =
  "CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS";
export const CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR =
  "CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR";

///productstocktransactionreason/update
export const UPDATE_PRODUCT_STOCK_TRANSACTION_REASON =
  "UPDATE_PRODUCT_STOCK_TRANSACTION_REASON";
export const UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS =
  "UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS";
export const UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR =
  "UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR";

///productstocktransactionreason/delete
export const DELETE_PRODUCT_STOCK_TRANSACTION_REASON =
  "DELETE_PRODUCT_STOCK_TRANSACTION_REASON";
export const DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS =
  "DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS";
export const DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR =
  "DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR";

///unitmeasurement/list
export const GET_UNIT_MEASUREMENT_LIST = "GET_UNIT_MEASUREMENT_LIST";
export const GET_UNIT_MEASUREMENT_LIST_SUCCESS =
  "GET_UNIT_MEASUREMENT_LIST_SUCCESS";
export const GET_UNIT_MEASUREMENT_LIST_ERROR =
  "GET_UNIT_MEASUREMENT_LIST_ERROR";
